/** InsCoder 2026-07-31 B + Accordion toggle for shipping calculator **/

(function () {
  'use strict';

  if (customElements.get('cust-cart-subtotal')) return;

  function initShippingAccordion(root, lifecycle) {
    var toggles = root.querySelectorAll('[data-js-shipping-toggle]');

    toggles.forEach(function (toggle) {
      // Prevent double binding
      if (toggle.dataset.shippingToggleInit) return;
      toggle.dataset.shippingToggleInit = 'true';

      var content = toggle.nextElementSibling;
      if (!content || !content.hasAttribute('data-js-shipping-content')) return;

      // Find parent .cust-shipping container for chevron rotation
      var container = toggle.closest('.cust-shipping');
      var isOpen = false;
      var animationTimer;
      content.style.display = 'none';
      content.style.removeProperty('height');
      content.style.removeProperty('overflow');
      container?.classList.remove('cust-shipping--open');

      lifecycle.listen(toggle, 'click', function () {
        lifecycle.cancel(animationTimer);
        isOpen = !isOpen;
        toggle.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          // Open
          content.style.removeProperty('display');
          var display = window.getComputedStyle(content).display;
          if (display === 'none') {
            content.style.display = 'block';
          }
          content.style.height = 'auto';
          var autoHeight = content.offsetHeight;
          content.style.height = '0px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // Force reflow
          content.style.height = autoHeight + 'px';
          content.setAttribute('aria-hidden', 'false');

          if (container) {
            container.classList.add('cust-shipping--open');
          }

          animationTimer = lifecycle.delay(function () {
            content.style.removeProperty('height');
            content.style.removeProperty('overflow');
          }, 200);
        } else {
          // Close
          content.style.height = content.offsetHeight + 'px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // Force reflow
          content.style.height = '0px';
          content.setAttribute('aria-hidden', 'true');

          if (container) {
            container.classList.remove('cust-shipping--open');
          }

          animationTimer = lifecycle.delay(function () {
            content.style.display = 'none';
            content.style.removeProperty('height');
            content.style.removeProperty('overflow');
          }, 200);
        }
      });

      // Keyboard support
      toggle.setAttribute('tabindex', '0');
      lifecycle.listen(toggle, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
      });

      // Set ARIA attributes
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    });
  }

  /** InsCoder 2026-07-31 B + Order note accordion toggle **/
  function initOrderNoteAccordion(root, lifecycle) {
    var toggles = root.querySelectorAll('[data-js-order-note-toggle]');

    toggles.forEach(function (toggle) {
      if (toggle.dataset.orderNoteToggleInit) return;
      toggle.dataset.orderNoteToggleInit = 'true';

      var content = toggle.nextElementSibling;
      if (!content || !content.hasAttribute('data-js-order-note-content')) return;

      var container = toggle.closest('.cust-order-note');
      var isOpen = false;
      var animationTimer;
      content.style.display = 'none';
      content.style.removeProperty('height');
      content.style.removeProperty('overflow');
      container?.classList.remove('cust-order-note--open');

      lifecycle.listen(toggle, 'click', function () {
        lifecycle.cancel(animationTimer);
        isOpen = !isOpen;
        toggle.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          content.style.removeProperty('display');
          var display = window.getComputedStyle(content).display;
          if (display === 'none') {
            content.style.display = 'block';
          }
          content.style.height = 'auto';
          var autoHeight = content.offsetHeight;
          content.style.height = '0px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // Force reflow
          content.style.height = autoHeight + 'px';
          content.setAttribute('aria-hidden', 'false');

          if (container) {
            container.classList.add('cust-order-note--open');
          }

          animationTimer = lifecycle.delay(function () {
            content.style.removeProperty('height');
            content.style.removeProperty('overflow');
          }, 200);
        } else {
          content.style.height = content.offsetHeight + 'px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // Force reflow
          content.style.height = '0px';
          content.setAttribute('aria-hidden', 'true');

          if (container) {
            container.classList.remove('cust-order-note--open');
          }

          animationTimer = lifecycle.delay(function () {
            content.style.display = 'none';
            content.style.removeProperty('height');
            content.style.removeProperty('overflow');
          }, 200);
        }
      });

      // Keyboard support
      toggle.setAttribute('tabindex', '0');
      lifecycle.listen(toggle, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle.click();
        }
      });

      toggle.setAttribute('role', 'button');
      toggle.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    });
  }

  /** InsCoder 2026-07-31 E + Order note accordion toggle **/

  /** InsCoder 2026-07-31 B + Shipping calculator button loading state **/
  function initShippingLoadingState(root, lifecycle) {
    var estimateBtns = root.querySelectorAll('.js-estimate-shipping');

    estimateBtns.forEach(function (estimateBtn) {
      if (estimateBtn.dataset.loadingInit) return;
      estimateBtn.dataset.loadingInit = 'true';

      var btnText = estimateBtn.querySelector('.button__text');
      var shippingCalc = estimateBtn.closest('shipping-calculator');
      if (!shippingCalc) return;

      var resultsBlockContent = shippingCalc.querySelector('.shipping-estimator__results-content');
      var alertEl = shippingCalc.querySelector('.shipping-estimator__results .alert');
      var loadingTimer = null;

      function restoreButton() {
        estimateBtn.style.removeProperty('opacity');
        estimateBtn.style.removeProperty('pointer-events');
        estimateBtn.classList.remove('cust-shipping__btn--loading');
        if (btnText) {
          var orig = btnText.getAttribute('data-original');
          if (orig) {
            btnText.textContent = orig;
            btnText.removeAttribute('data-original');
          }
        }
        if (loadingTimer) {
          lifecycle.cancel(loadingTimer);
          loadingTimer = null;
        }
      }

      restoreButton();

      lifecycle.listen(estimateBtn, 'click', function () {
        lifecycle.cancel(loadingTimer);
        // Store original text
        if (btnText) {
          var orig = btnText.textContent.replace(/…+$/, '').trim();
          btnText.setAttribute('data-original', orig);
          btnText.textContent = orig + '…';
        }
        estimateBtn.style.opacity = '0.5';
        estimateBtn.style.pointerEvents = 'none';
        estimateBtn.classList.add('cust-shipping__btn--loading');

        // Safety timeout: restore after 15 seconds if no response
        loadingTimer = lifecycle.delay(function () {
          restoreButton();
        }, 15000);
      });

      // Observer: detect when results become visible (fetch complete)
      if (resultsBlockContent) {
        var contentObserver = new MutationObserver(function () {
          if (resultsBlockContent.style.display !== 'none') {
            restoreButton();
          }
        });
        lifecycle.observers.add(contentObserver);
        contentObserver.observe(resultsBlockContent, {
          attributes: true,
          attributeFilter: ['style']
        });
      }

      // Observer: detect error alert visibility
      if (alertEl) {
        var alertObserver = new MutationObserver(function () {
          if (alertEl.style.display !== 'none') {
            restoreButton();
          }
        });
        lifecycle.observers.add(alertObserver);
        alertObserver.observe(alertEl, {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    });
  }

  /** InsCoder 2026-07-31 E + Shipping calculator button loading state **/

  /** InsCoder 2026-09-15 B + Reinitialize cart subtotal after AJAX replacement **/
  customElements.define('cust-cart-subtotal', class extends HTMLElement {
    connectedCallback() {
      this.renderObserver?.disconnect();
      this.renderObserver = new MutationObserver(() => this.initialize());
      this.renderObserver.observe(this, { childList: true });
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      this.renderObserver?.disconnect();
      this.cleanup();
    }

    cleanup() {
      this.bindings?.abort();
      this.timers?.forEach(timer => clearTimeout(timer));
      this.observers?.forEach(observer => observer.disconnect());
      this.querySelectorAll('[data-shipping-toggle-init], [data-order-note-toggle-init], [data-loading-init]').forEach(element => {
        delete element.dataset.shippingToggleInit;
        delete element.dataset.orderNoteToggleInit;
        delete element.dataset.loadingInit;
      });
    }

    initialize() {
      if (!this.isConnected) return;
      this.cleanup();
      this.bindings = new AbortController();
      this.timers = new Set();
      this.observers = new Set();
      initShippingAccordion(this, this);
      initOrderNoteAccordion(this, this);
      initShippingLoadingState(this, this);

      const checkoutLabel = this.querySelector('[data-cart-checkout-label]');
      const outerLabel = this.closest('#site-cart-sidebar')?.querySelector('.outer-checkout-button [name="checkout"] .button__text');
      if (checkoutLabel && outerLabel) {
        outerLabel.textContent = checkoutLabel.textContent;
      }
    }

    listen(element, event, callback) {
      element.addEventListener(event, callback, { signal: this.bindings.signal });
    }

    cancel(timer) {
      clearTimeout(timer);
      this.timers.delete(timer);
    }

    delay(callback, duration) {
      const timer = setTimeout(() => {
        this.timers.delete(timer);
        if (this.isConnected) callback();
      }, duration);
      this.timers.add(timer);
      return timer;
    }
  });
  /** InsCoder 2026-09-15 E + Reinitialize cart subtotal after AJAX replacement **/

})();

/** InsCoder 2026-07-31 E + Accordion toggle for shipping calculator **/
